<template>
  <div class="creativeTable">
    <heading type="h4">Editable Fields</heading>
    <slot-table id="creativeTable" :data="tableData" :columns="table.columns" @toggleCheckboxes="toggleParentCheckboxes">
      <template slot="is_editable" slot-scope="props">
          <span><checkbox :id="`checkbox_${props.item.id}`" v-model="props.item.is_editable"
                          :value="props.item.is_editable"/></span>
      </template>
      <template slot="type" slot-scope="props">
        <span class="text-capitalize">{{ props.item.type }}</span>
      </template>
      <template slot="limit" slot-scope="props">
          <span><field v-if="props.item.type === 'string'" type="number" v-model="props.item.limit"
                       :value="props.item.limit" /></span>
      </template>
      <template slot="is_hard_limit" slot-scope="props">
          <span>
            <switch-button v-if="props.item.type === 'string'" :id="`switch_${props.item.id}`"
                           v-model="props.item.is_hard_limit" :on="props.item.is_hard_limit"/></span>
      </template>

      <template slot="editableActions" slot-scope="props" >
        <div class="buttonsWrapper">
              <span v-if="props.item.editableActions && ((props.item.default_values && props.item.default_values.length > 1) || (props.item.type === 'image' && props.item.image_preview))">
                <button-cta :onClick="()=>togglePreviewRow(props.item)" class="btn btn-info btn-xs">
                  <i class="fa fa-chevron-right" :id="`chevron_${props.item.id}`" aria-hidden="true"></i>
                </button-cta>
              </span>
        </div>
      </template>

    </slot-table>

  </div>
</template>

<script>
import SlotTable from '@/components/Table/table'
import ButtonCta from '@/components/Button/button'
import Heading from '@/components/Heading/heading'
import Field from '@/components/Form/Field/field'
import SwitchButton from '@/components/SwitchButton/switch-button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
import {modalMixin} from '@/mixins/modalMixin'

import { url } from '@/config'

export default {
  name: 'CreativeTable',
  components: {
    SlotTable,
    ButtonCta,
    Field,
    SwitchButton,
    Checkbox,
    Heading
  },
  mixins: [modalMixin],
  props: {
    tableData: Array
  },
  data: () => ({
    table: {
      columns: {
        is_editable: 'allCheckboxes',
        name: 'Name',
        type: 'Type',
        limit: 'Limit',
        is_hard_limit: 'HardLimit',
        defaultValue: 'Default Value',
        editableActions: ''
      }
    }
  }),
  computed: {},
  methods: {
    toggleParentCheckboxes (toggle) {
      this.$emit('onToggleParentCheckboxes', toggle)
    },
    assetUrl (path) {
      return `${url}${path.charAt(0) === '/' ? path.substring(1) : path}` // need to remove leading slash
    },
    togglePreviewRow (item) {
      const rowId = item.id
      const type = item.type
      const previewRow = `previewRow__${rowId}`
      const chevron = document.getElementById(`chevron_${rowId}`)

      // toggle chevron
      if (chevron.classList.contains('fa-chevron-right')) {
        chevron.classList.remove('fa-chevron-right')
        chevron.classList.add('fa-chevron-down')
      } else {
        chevron.classList.add('fa-chevron-right')
        chevron.classList.remove('fa-chevron-down')
      }

      // if already created lets just toggle hidden class
      if (document.contains(document.getElementById(previewRow))) {
        const row = document.getElementById(previewRow)
        if (row.classList.contains('hidden')) {
          row.className = ''
          return
        }
        row.className = 'hidden'
        return
      }

      const target = document.getElementById(rowId)
      const newElement = document.createElement('tr')
      newElement.id = previewRow
      target.parentNode.insertBefore(newElement, target.nextSibling)
      const cell = newElement.insertCell(0)
      cell.colSpan = '7'

      const defaults = item.default_values
      const path = item.image_preview

      if (defaults && defaults.length) {
        defaults.forEach((defaultValue) => {
          if (type === 'image') {
            const defaultByMaster = `${item.image_preview_prefix}/${defaultValue.value}`
            const imageSrc = `${url}${defaultByMaster.charAt(0) === '/' ? defaultByMaster.substring(1) : defaultByMaster}`
            const img = document.createElement('img')
            img.src = imageSrc
            cell.appendChild(img)
          } else {
            const p = document.createElement('p')
            p.appendChild(document.createTextNode(`${defaultValue.master}: ${defaultValue.value}`))
            cell.appendChild(p)
          }
        })
      } else {
        if (type === 'image') {
          const imageSrc = `${url}${path.charAt(0) === '/' ? path.substring(1) : path}`
          const img = document.createElement('img')
          img.src = imageSrc
          cell.appendChild(img)
        }
      }

      cell.className = 'creativeTable__preview'
      return cell
    }
  }
}
</script>

<style lang="scss">
    .creativeTable {
      &__preview {
        text-align: center;
        img {
          padding: 15px 0;
        }
      }
    }
    .buttonsWrapper{
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      span + span {
        margin-left: 5px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/CreativeTable/creative-table.vue